// removed by extract-text-webpack-plugin
module.exports = {"content":"src-pages----home-module---content---t49CP"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/home.module.scss
// module id = 297
// module chunks = 35783957827783